<template>
    <!-- <div :class="['alt-engraving__design-modal',{'active': showModal}]"> -->
    <div class="alt-engraving__design-modal"  @click="closeModalOnClickOutside">
        <div class="alt-engraving__modal-content" @click.stop>
            <h4 class="alt-engraving__modal-title">Engrave your design</h4>
            <div class="alt-engraving__modal-description">
                <p>Choose your font style. Write a name or blessing. Add symbol with a click.</p>
                <p class="alt-engraving__note">*{{ engravingSettings.engravingNote }}</p>
            </div>
            <div class="alt-engraving__modal-preview">
                <span class="alt-elegant-font" v-html="previewContent"></span>
            </div>
            <div class="alt-engraving__select-font alt-engraving__modal-step">
                <span class="alt-engraving__step-title">STEP 1: Choose your font style</span>
                <div class="alt-engraving__fonts">
                    <span
                        v-for="font in fonts"
                        :data-font="font.class"
                        :data-fontname="font.label"
                        :key="font.name"
                        @click="selectFonts(font.name)"
                        :class="[font.class, { active: selectedFont === font.name }]">
                        {{ font.label }}
                    </span>
                </div>
            </div>
            <div class="alt-engraving__text-editor alt-engraving__modal-step">
                <span class="alt-engraving__step-title">STEP 2: Write a name or blessing</span>
                <div class="alt-engraving__input-editor">
                    <div class="alt-engraving__input-field">
                        <label class="alt-engraving__input-label">Your Engraving</label>
                        <div class="alt-engraving__input-container">
                            <input type="text" @focus="focusInput" @blur="blurInput" @keyup="changeValueInput" id="alt-engraving__input" name="alt-engraving__input" class="alt-engraving__input alt-elegant-font">
                        </div>
                    </div>
                </div>
            </div>
            <div class="alt-engraving__select-symbols alt-engraving__modal-step" v-if="icons.length>0">
                <span class="alt-engraving__step-title">Insert your symbol(s) into your engraving (Optional)</span>
                <div class="alt-engraving__symbols">
                    <span
                        v-for="(icon, index) in icons"
                        :key="index"
                        @click="insertSymbol(icon.value)"
                        :data-value="icon.value">
                        <img :src="icon.src" :alt="icon.alt" />
                    </span>
                </div>
            </div>
            <span class="alt-engraving__character-count" v-html="charactercount"></span>
            <div class="alt-engraving__confirm-modal">
                <a href="#" @click="confirm_engraving_design_modal($event)" class="alt-engraving__confirm-button disabled" data-item="1">Done</a>
            </div>
            <span @click="closepopup_engraving_design_modal" class="alt-engraving__modal-close">×</span>
        </div>
    </div>
</template>
<style lang="scss">
    @import "@/assets/scss/components/product/_engraving_modal.scss";
</style>

<script lang="ts" setup >
import {defineProps, ref, computed} from 'vue';
    const emit = defineEmits(['update:value','customiseUpdateFont','updateStatus', 'close', 'sendEngravingData']);
    const props = defineProps<{
        value: string,
        keyModal: number,
        engravingSettings: {
            isHideSymbol: boolean;
            isHideCursive: boolean;
            engravingNote:string;
            limitCharacter: string;
            limitElegantCharacter:string;
            limitCursiveCharacter:string;
        };
    }>();
    const engravingSettings = computed(() => props.engravingSettings);
    const fontArr = ['alt-chinese-font', 'alt-cursive-font', 'alt-elegant-font'];
    const previewContent = ref('Your Engraving');
    const charactercount = ref(`${engravingSettings.value.limitElegantCharacter}/${engravingSettings.value.limitElegantCharacter} characters left`);
    const selectedFont = ref('alt-elegant-font');
    const validate: { [key: string]: string } = {
        "alt-chinese-font" : engravingSettings.value.limitCharacter,
        "alt-elegant-font" : engravingSettings.value.limitElegantCharacter,
        "alt-cursive-font" : engravingSettings.value.limitCursiveCharacter,
    }
    const localValue = computed({
        get() {
            return props.value;
        },
        set(newValue) {
            emit('update:value', newValue);
            
        }
    });
    let fonts = [
            { name: 'alt-elegant-font', class: 'alt-elegant-font', label: 'Elegant' },
            { name: 'alt-cursive-font', class: 'alt-cursive-font', label: 'Cursive' },
            { name: 'alt-chinese-font', class: 'alt-chinese-font', label: 'Chinese' },
        ] 
    if (engravingSettings.value && engravingSettings.value.isHideCursive){
        fonts = [
            { name: 'alt-elegant-font', class: 'alt-elegant-font', label: 'Elegant' },
            { name: 'alt-chinese-font', class: 'alt-chinese-font', label: 'Chinese' },
        ]
    }
    
    let icons = [
        { value: '♡', src: '/single-product/heart-icon.webp', alt: 'heart icon' },
        { value: '☆', src: '/single-product/star-icon.webp', alt: 'star icon' },
        { value: '✞​', src: '/single-product/cross-icon.webp', alt: 'cross icon' },
        { value: '∞', src: '/single-product/infinity-icon.webp', alt: 'infinity icon' },
    ]
    const isHideSymbolFixed = ref(true);
    // if (engravingSettings.value && engravingSettings.value.isHideSymbol && isHideSymbolFixed.value){
    if (isHideSymbolFixed.value){
        icons = [];
    }
    
    const closepopup_engraving_design_modal = () => {
        emit('close')
    };
    const closeModalOnClickOutside = () => {
        emit('close');
    };

    const confirm_engraving_design_modal = (event: Event) => {
        event.preventDefault()
        const engravingSelected = document.querySelector('.alt-engraving__design-modal') as HTMLElement | null;
        const engravingInput = document.querySelector('.alt-engraving__input') as HTMLInputElement | null;
        const add_to_cart = document.querySelector('.add-to-cart-btn-modal') as HTMLElement | null;
        const fontSelected = document.querySelector(".alt-engraving__fonts .active") as HTMLElement;
        if (engravingSelected && engravingInput) {
            localValue.value = engravingInput.value;
            // add_to_cart.classList.add('active');
            // engravingSelected.classList.remove('active');
            emit('close')
            emit('updateStatus');
            emit('sendEngravingData', {
                text: engravingInput.value,
                font: fontSelected ? fontSelected.getAttribute("data-font") : '',
            });
        }
    };

    const focusInput = () => {
        const engravingFocus = document.querySelector('.alt-engraving__input-field') as HTMLElement | null;
        if (engravingFocus) {
            engravingFocus.classList.add('focused');
        }
    };

    const blurInput = () => {
        const engravingFocus = document.querySelector('.alt-engraving__input-field') as HTMLElement | null;
        const valueInput = document.querySelector('.alt-engraving__input') as HTMLInputElement | null;
        if (engravingFocus && valueInput) {
            if (!valueInput.value) {
                engravingFocus.classList.remove('focused');
            }
        }
    };

    const changeValueInput = () => {
        const valueInput = document.querySelector('.alt-engraving__input') as HTMLInputElement | null;
        const currentFontElement = document.querySelector('.alt-engraving__fonts span.active') as HTMLElement | null;
        if (valueInput && currentFontElement) {
            const currentFont = currentFontElement.getAttribute('data-font') || '';
            const maxLength = parseInt(validate[currentFont] || '0');
            const inputVal = valueInput.value;
            if (inputVal) {
                // console.log(maxLength)
                if (inputVal.length > maxLength) {
                    const newVal = inputVal.slice(0, maxLength);
                    valueInput.value = newVal;
                    previewContent.value = newVal;
                } else {
                    previewContent.value = inputVal;
                }
            }else{
                previewContent.value = 'Your Engraving';
            }
            validateEngravingBtn();
            countInputCharacters(currentFont);
        }
    };

    const selectFonts = (index: string) => {
        selectedFont.value = index;
        
        
        const maxLength = parseInt(validate[index] || '0');
        const classFont = document.querySelector('.alt-engraving__modal-preview span') as HTMLElement | null;
        const valueInput = document.querySelector('.alt-engraving__input') as HTMLInputElement | null;
        
        if (valueInput && classFont) {
            const inputVal = valueInput.value;
            if (inputVal.length > maxLength) {
                const newVal = inputVal.slice(0, maxLength);
                
                valueInput.value = newVal;
                previewContent.value = newVal;
            }
            fontArr.forEach((font) => {
                classFont.classList.remove(font);
                valueInput.classList.remove(font);
            });

            classFont.classList.add(index);
            valueInput.classList.add(index);
            validateEngravingBtn();
            countInputCharacters(index);
            fonts.forEach((font) => {
                if (font.name === index) {
                emit('customiseUpdateFont', font.label);
                }
            });
            
        }
    };

    const insertSymbol = (index: string) => {
        const currentFontElement = document.querySelector('.alt-engraving__fonts span.active') as HTMLElement | null;
        const valueInput = document.querySelector('.alt-engraving__input') as HTMLInputElement | null;
        if (currentFontElement && valueInput) {
            focusInput();
            const inputVal = valueInput.value;
            const selectionStart = valueInput.selectionStart || 0;
            const selectionEnd = valueInput.selectionEnd || 0;
            const currentFont = currentFontElement.getAttribute('data-font') || '';
            const maxLength = parseInt(validate[currentFont] || '0');
            const symbolWithoutZWSP = index.replace(/\u200B/g, '');
            if (inputVal.length < maxLength) {
                const newVal = inputVal.slice(0, selectionStart) + symbolWithoutZWSP + inputVal.slice(selectionEnd);
                if (newVal) {
                    valueInput.value = newVal;
                    previewContent.value = newVal;
                }
                const newCaretPosition = selectionStart + symbolWithoutZWSP.length;
                valueInput.setSelectionRange(newCaretPosition, newCaretPosition);
                valueInput.focus();
            }
            validateEngravingBtn();
            countInputCharacters(currentFont);
        }
    };

    const validateEngravingBtn = () => {
        const valueInput = document.querySelector('.alt-engraving__input') as HTMLInputElement | null;
        const confirmBtn = document.querySelector('.alt-engraving__confirm-button') as HTMLElement | null;
        if (valueInput && confirmBtn) {
            const inputVal = valueInput.value;
            if (inputVal) {
                confirmBtn.classList.remove('disabled');
            } else {
                confirmBtn.classList.add('disabled');
            }
        }
    };

    const countInputCharacters = (index: string) => {
        const valueInput = document.querySelector('.alt-engraving__input') as HTMLInputElement | null;
        const maxLength = parseInt(validate[index] || '0');
        if (valueInput) {
            const inputVal = valueInput.value;
            charactercount.value = `${maxLength - inputVal.length}/${maxLength} characters left`;
        }
    };

    onMounted(() => {
        if(props.value && props.value !== "Write a Name or Blessing"){
            previewContent.value = props.value;
            const valueInput = document.querySelector('.alt-engraving__input') as HTMLInputElement | null;
            const confirmBtn = document.querySelector('.alt-engraving__confirm-button') as HTMLElement | null;
            if (valueInput && confirmBtn){
                valueInput.value = props.value;
                confirmBtn.classList.remove('disabled');
                focusInput()
            }
        }
    })
</script>